import React, { useState, useEffect } from 'react';
import Dropzone from 'react-dropzone-uploader';
import { FormattedMessage } from 'react-intl';
import { DEFAULT_LANGUAGE, uploadLink } from '../../config';
import SessionManager from "../../utils/authHandling/session-manager";
import Button from 'react-bootstrap/Button';

// Component to upload an image for a lesson
const LessonImageUploader = ({ src, lessonSubject, lessonGrade, language, onChange, fileRules }) => {
  const [stringImageSrc, setStringImageSrc] = useState(null);
  const [uploadType] = useState("image");
  const [dropzoneResponseObject, setDropzoneResponseObject] = useState(null);

  useEffect(() => {
    if (src) {
      setStringImageSrc(src);
    }
  }, [src]);

  // Get the upload parameters when uploading an image
  const getUploadParams = (headers) => {
    setDropzoneResponseObject(headers);
    
    return { 
      url: uploadLink
        + "subject=" + lessonSubject
        + "&level=" + lessonGrade 
        + "&uploadType=" + uploadType 
        + "&langCode=" + language
        + "&isLessonImg=true",
      headers: {
        'Token': SessionManager.getSession(),
        'Accept-Language': localStorage.getItem('i18nextLng') == null ? DEFAULT_LANGUAGE : localStorage.getItem('i18nextLng')
      }
    };
  };

  // Check if the file is valid
  const validateFiles = (droppedFile) => {
    let appliedRules = {};
    let messages = [];

    if(fileRules === null || fileRules === undefined){
      alert("File Rules are missing");
    } 
    else {
      fileRules.forEach((item) => {
        let typeString = item.Classification + "/" + item.Format;
        if(typeString === droppedFile.meta.type){
          appliedRules = item;
        } 
      });

      if(droppedFile.meta.size > appliedRules.MaxSize){
        messages.push("File size is too large");
      }
      if(droppedFile.meta.height > appliedRules.MaxHeight){
        messages.push("File heigth is too large");
      }
      if(droppedFile.meta.width > appliedRules.MaxWidth){
        messages.push("File width is too large");
      }
      if(!lessonSubject){
        messages.push("Must select a subject");
      }
      if(!lessonGrade){
        messages.push("Must select a grade");
      }
      if(messages.length > 0){
        droppedFile.remove();
        alert(messages);
      }
    }
  };

  // Set the image source when submitted
  const handleSubmit = (files, allFiles) => {
    let response = JSON.parse(dropzoneResponseObject.xhr.responseText);
    onChange("lessonImgSrc", response.Messages[0]);
    allFiles.forEach(f => f.remove())
  };

  const removeImage = () => {
    onChange("lessonImgSrc", null);
    setStringImageSrc(null);
  }

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
  };

  return (
    <div>
      <b><FormattedMessage id="cl-lesson-intro-image"/></b>
      <br />
      <span style={{fontSize: '14px', color: 'gray'}}>
        <FormattedMessage id="cl-lesson-image-resize"/>
      </span>
      {stringImageSrc ? (
        <div>
          <p className='small'>Preview:</p>
          <img
            src={stringImageSrc}
            style={{ 
              margin: "10px",
              objectFit: "cover",
              width: "320px",
              height: "180px"
            }}
            alt="Preview Image"
          />
          <p>
            <Button onClick={removeImage}>
              <FormattedMessage id="cl-lesson-new-image"/>
            </Button>
          </p>
        </div>
      )
      :
      <div>
        <Dropzone
          accept="image/png, image/jpeg, image/jpg"
          key="Dropzone View"
          validate={validateFiles}
          getUploadParams={getUploadParams}
          maxFiles={1}
          onSubmit={handleSubmit}
          styles={{ dropzone: baseStyle }}
          inputContent={<FormattedMessage id={"u-image"}/>}
        />
      </div>
      }
      <div>
      </div>
    </div>
  );
};

export default LessonImageUploader;